import React from 'react';
import PropTypes from 'prop-types';

import './Button.css';

const Button = ({
	uniqueId,
	bsClassSuffix,
	size,
	iconName,
	showSpinner,
	text,
	isDisabled,
	clickHandler,
	mouseDownHandler,
	mouseUpHandler,
	className,
}) => (

	<button
		id={uniqueId}
		className={`btn btn-${bsClassSuffix || 'info'} ${size} ${className || ''} d-flex justify-content-center align-items-center`}
		onClick={clickHandler}
		onMouseDown={mouseDownHandler}
		onMouseUp={mouseUpHandler}
		disabled={isDisabled || false}>

		{(iconName || showSpinner) && (
			<div className="btn-icon-slot">
				{iconName && (
					<i className="material-icons">{iconName}</i>
				)}
				{showSpinner && (
					<div className="spinner-border spinner-border-sm" />
				)}
			</div>
		)}
		{text && <span className={(iconName || showSpinner) ? 'ml-1' : ''}>{text}</span>}
	</button>
);

Button.propTypes = {
	uniqueId: PropTypes.string,
	bsClassSuffix: PropTypes.string,
	size: PropTypes.string,
	iconName: PropTypes.string,
	showSpinner: PropTypes.oneOf([undefined, false, true]),
	text: PropTypes.string,
	isDisabled: PropTypes.oneOf([undefined, false, true]),
	clickHandler: PropTypes.func.isRequired,
	mouseDownHandler: PropTypes.func,
};

export default React.memo(Button);
